import { useMutation } from "@apollo/client";
import SplitIOContext from "context/splitio-context";
import UserContext from "context/user-context";
import { UNIT_APPLICATION } from "graphql/mutations/session";
import { useContextStrict } from "helpers/context-strict";
import ApplicationFormV2 from "pages/application-form-v2";
import ApplicationStatusV2 from "pages/application-status-v2";
import { useContext, useEffect, useState } from "react";

function ApplicationForm() {
  const [applicationFormGetCreate, { loading, data }] =
    useMutation(UNIT_APPLICATION);
  const splits = useContextStrict(SplitIOContext);
  const user = useContext(UserContext);
  useEffect(
    () => setSe2147flag(splits.isTreatmentOn(splits.act.se2147)),
    [splits]
  );
  const [se2147flag, setSe2147flag] = useState<boolean>();

  useEffect(() => {
    if (!loading && data) {
      const timeout = setTimeout(() => {
        window.location.replace(data.spendUnitApplication.url);
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, [loading, data]);

  useEffect((): void => {
    if (se2147flag === false) {
      applicationFormGetCreate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [se2147flag]);

  // application v1 has no ui, it is redirected after 1s
  if (!se2147flag) {
    return null;
  }
  // if user has an application in process, show them the application status page
  return user?._session?.applicationId ? (
    <ApplicationStatusV2 applicationId={user?._session?.applicationId} />
  ) : (
    // otherwise go to the form to create an application
    <ApplicationFormV2 />
  );
}

export default ApplicationForm;
